module.exports = __webpack_public_path__ + "img/background-0-3.733aa50a.jpg";